import File from "./file";

export default class ProductImage {

    constructor(data, productId) {
        this.default = false;
        this.name = '';
        this.pos = 0;
        this.productId = productId;
        this.classes = new Map();

        this.classes.set('fade', 'fade');

        Object.assign(this, data);

        this.file = new File(data.file);
    }

    get id() {
        return this.productId + '-' + this.file.hash;
    }

    get class() {
        return Array.from(this.classes.keys()).join(' ');
    }

    show() {
        this.classes.delete('from-left');
        this.classes.delete('from-right');
        this.classes.delete('fade');
        this.classes.set('show', 'show');
    }

    setDirection(direction) {
        this.classes.delete('from-left');
        this.classes.delete('from-right');
        this.classes.set(`from-${direction}`, `from-${direction}`);
    }

    hide() {
        this.classes.delete('show');
        this.classes.set('fade', 'fade');
    }
}
